import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';

export const menuDrawer = [
  {
    nombre: "Inicio",
    iconName: HomeOutlinedIcon,
    click: '/home'
  },
  {
    nombre: "Mis servicios",
    iconName: LanguageOutlinedIcon,
    click: '/user/servicios'
  },
  {
    nombre: "Reservas",
    iconName: EventNoteOutlinedIcon,
    click: '/user/reservas-proveedor'
  },
  {
    nombre: "Favoritos",
    iconName: FavoriteBorderOutlinedIcon,
    click: '/user/favoritos'
  },
  {
    nombre: "Mensajes",
    iconName: EmailOutlinedIcon,
    click: '/mensajes'
  },
  {
    nombre: "Mis tickets",
    iconName: SupportAgentOutlinedIcon,
    click: '/user/tickets'
  },
  {
    nombre: "Perfil",
    iconName: SettingsOutlinedIcon,
    click: '/mi-perfil'
  }
];